<div class="overlay">
  <!-- Fondo borroso -->
  <div class="blur-background"></div>

  <!-- Logo (fuera del div borroso) -->
  <div class="loader-logo">
    <img src="../../../assets/images/EDUTEGIA 1.png" alt="Logo">
  </div>
</div>
